import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from '@/components/LocalizedLink';
import { useApiData } from '@/hooks/useApiData';
import { fadeUp, revealOnce } from '@/lib/motion';

const NO_ITEMS = [];

function CountryCard({ market, index }) {
  return (
    <motion.div {...revealOnce} variants={fadeUp} transition={{ delay: index * 0.08, duration: 0.5 }}>
      <Link
        to={`/market/${market.slug}`}
        className="group flex h-full flex-col bg-white p-6 rounded-lg border border-saffron-100/50 shadow-card-lift hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300"
        data-testid={`country-card-${market.slug}`}
      >
        <span className="flex items-center gap-2 text-xs uppercase tracking-wider text-saffron font-sans font-semibold">
          <MapPin size={14} /> {market.country}
        </span>
        <h3 className="mt-3 font-display text-base font-bold text-earth-dark group-hover:text-saffron transition-colors">
          {market.h1 || `Indian Spice Powders for ${market.country}`}
        </h3>
        <span className="mt-auto pt-4 flex items-center gap-1 text-saffron font-sans text-xs font-semibold group-hover:gap-2 transition-all">
          View country guide <ArrowRight size={12} />
        </span>
      </Link>
    </motion.div>
  );
}

export default function CountryGuides() {
  const { data: markets } = useApiData('/api/landing-pages', NO_ITEMS);
  if (markets.length === 0) return null;
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-saffron-50/30" data-testid="country-guides">
      <div className="max-w-7xl mx-auto">
        <motion.div {...revealOnce} variants={fadeUp} className="mb-10">
          <span className="text-xs uppercase tracking-[0.3em] text-saffron font-sans font-semibold">Country Guides</span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-earth-dark mt-3 tracking-tight">Exporting to Your Country</h2>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {markets.map((market, i) => <CountryCard key={market.slug} market={market} index={i} />)}
        </div>
      </div>
    </section>
  );
}
